import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=501b7c20&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"
import style0 from "./pagination.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pagination.vue?vue&type=style&index=1&id=501b7c20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b7c20",
  null
  
)

export default component.exports